import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "svg-slot me-2" }
const _hoisted_2 = { class: "text-slot w-100" }

import { computed } from 'vue'


interface Props {
    background?: string
}

// props

export default /*@__PURE__*/_defineComponent({
  __name: 'Banner',
  props: {
    background: {}
  },
  setup(__props: any) {

const props = __props

// computed
const styles = computed(() => {
    return {
        background: props.background,
    }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "banner d-flex flex-row nowrap align-items-center bg-green-100",
    style: _normalizeStyle(styles.value)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "svg")
    ]),
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "text")
    ])
  ], 4))
}
}

})